<template>
  <div class="demoPage">
    <el-button @click="showBox = true">
      showspGuideBox
    </el-button>
    <SpGuideBox
      v-model="showBox"
      :call-data="callData"
      @getUserList="getUserList"
    />

    <el-button @click="()=>run()">
开始测试
</el-button>
    <div v-if="Loding">
      <el-button @click="login">
点击登录
</el-button>
    </div>
  </div>
</template>

<script>
import SpGuideBox from '@/components/guideBox/index'
import { logicInfo1 } from './test/test'
import hooks,{runBlockNode,getNextPath,blockNode,} from './test/hooks'

export default {
  components: {
    SpGuideBox
  },

  data () {
    return {
      showBox: false,
      callData: {},
      logicInfo1,
      Loding:false
    }
  },
  mounted () {},
  methods: {
    getUserList (e) {
      console.log('getUserList', e)
      this.callData = e
    },
    closeGuideBox () {
      this.showBox = false
    },

    async run (){
      let that = this
      
      this.runHook(this.logicInfo1.rootNode,null)
      // const res = await hooks[node.action].call(that,node)
      // console.log(res)
    },
    login (){
      runBlockNode()      
    },
    async runHook (node,opts){
      console.log('node1',node)
      const res = await hooks[node.action].call(this,node,opts)
      console.log('runHook-res',res)
      let nextNode = getNextPath(node,res)
     
      if(nextNode)this.runHook(nextNode,res)
    }
  }
}
</script>

<style lang="scss" scoped>
.demoPage {
  border-top: 1px solid #333;
  padding-top: 60px;
}
</style>
